// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2PC_i","header":"Messages_header__1OjMM"};